import { Card } from '@splitfiesta/ui';

interface AuthPageSkeletonProps {
  fieldCount?: number;
}

export function AuthPageSkeleton({ fieldCount = 2 }: AuthPageSkeletonProps) {
  return (
    <div className="min-h-screen bg-linear-to-br from-orange-400 to-red-400">
      <div className="min-h-screen p-4 pt-4">
        <div className="max-w-md w-full mx-auto">
          {/* Language Switcher skeleton - Close to top */}
          <div className="flex justify-end mb-3">
            <div className="h-10 bg-white/20 rounded-full w-24 animate-pulse"></div>
          </div>

          {/* Logo skeleton - Second row */}
          <div className="text-center mb-8">
            <div className="h-10 bg-white/20 rounded-sm w-48 mx-auto mb-2 animate-pulse"></div>
            <div className="h-6 bg-white/20 rounded-sm w-64 mx-auto animate-pulse"></div>
          </div>

          {/* Form skeleton */}
          <Card>
            <div className="animate-pulse space-y-6">
              <div>
                <div className="h-8 bg-gray-200 rounded-sm w-32 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded-sm w-48"></div>
              </div>

              <div className="space-y-4">
                {Array.from({ length: fieldCount }).map((_, i) => (
                  <div key={i}>
                    <div className="h-4 bg-gray-200 rounded-sm w-20 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded-sm"></div>
                  </div>
                ))}
              </div>

              <div className="h-10 bg-orange-300 rounded-sm"></div>

              <div className="h-4 bg-gray-200 rounded-sm w-full"></div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
